import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Users, Anchor, Share2, Download } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
export function HomePage() {
  return <div data-id="element-435">
      {/* Hero Section — Centered Text */}
      <section className="py-28 md:py-36 lg:py-44 px-4 sm:px-6 lg:px-8" data-id="element-436">
        <div className="max-w-4xl mx-auto text-center" data-id="element-437">
          <AnimatedSection data-id="element-438">
            <p className="text-lg text-brand-brown mb-6 leading-relaxed" data-id="element-439">
              Finding impactful organisations is hard. Knowing the ones with
              solid leadership, processes and governance, is harder still.
            </p>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-200" data-id="element-440">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-charcoal leading-tight mb-6" data-id="element-441">
              Firetree offers funders curated access to established,
              high-capacity local organizations with proven models in Southeast
              Asia.
            </h1>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-300" data-id="element-442">
            <p className="text-base text-brand-brown mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-443">
              Each organisation in this portfolio has been selected by members
              of the Firetree team who have created, run and backed
              organisations themselves.
            </p>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-400" data-id="element-444">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-445">
              <Link to="/how-we-work" className="inline-flex items-center justify-center px-8 py-3.5 bg-brand-red text-white font-semibold rounded-full hover:bg-brand-charcoal transition-all duration-300 shadow-sm hover:shadow-md group" data-id="element-446">
                Who we are
                <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-447" />
              </Link>
              <a href="#" className="inline-flex items-center justify-center px-8 py-3.5 border border-brand-red text-brand-red font-semibold rounded-full hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-448">
                <Download className="mr-2 w-4 h-4" data-id="element-449" />
                Download prospectus
              </a>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Image Breaker 1 - Rice Terraces */}
      <AnimatedSection data-id="element-450">
        <div className="relative h-64 md:h-96 w-full overflow-hidden" data-id="element-451">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform hover:scale-105 transition-transform duration-1000" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1555400038-63f5ba517a47?q=80&w=2070&auto=format&fit=crop")'
        }} data-id="element-452" />
          <div className="absolute inset-0 bg-brand-charcoal/20 mix-blend-multiply" data-id="element-453" />
          <div className="absolute inset-0 bg-texture-overlay mix-blend-overlay" data-id="element-454" />
        </div>
      </AnimatedSection>

      {/* How We Work Summary */}
      <section className="bg-brand-card/30 py-24" data-id="element-455">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-456">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-end mb-16" data-id="element-457">
            <AnimatedSection data-id="element-458">
              <div data-id="element-459">
                <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-460">
                  How we work
                </h2>
                <p className="text-xl text-brand-brown" data-id="element-461">
                  We have built our expertise over 20 years of working with
                  organisations, within organisations to understand the regions,
                  issues and communities that we work in.
                </p>
              </div>
            </AnimatedSection>
            <AnimatedSection delayClass="delay-200" data-id="element-462">
              <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-4 lg:items-end lg:justify-end" data-id="element-463">
                <Link to="/how-we-work" className="inline-flex items-center px-6 py-3 border border-brand-red text-brand-red font-semibold rounded-full hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-464">
                  Read more about our approach
                  <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-465" />
                </Link>
                <Link to="/our-process" className="inline-flex items-center px-6 py-3 border border-brand-red text-brand-red font-semibold rounded-full hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-466">
                  Our process
                  <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-467" />
                </Link>
              </div>
            </AnimatedSection>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-468">
            <AnimatedSection delayClass="delay-100" data-id="element-469">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-470">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-471">
                  <Building2 className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-472" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-473">
                  We operate, not just fund
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-474">
                  We fully fund and operate TCI in Manila and Starfish Education
                  Foundation in Thailand.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-200" data-id="element-475">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-476">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-477">
                  <Users className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-478" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-479">
                  We've been in the room
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-480">
                  We have lived through the day-to-day challenges of the
                  leadership. With Board experience across 20+ organisations, we
                  know what good governance and decision making under pressure
                  looks like.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-300" data-id="element-481">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-482">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-483">
                  <Anchor className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-484" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-485">
                  We stay
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-486">
                  We know that multi-year, unrestricted funding partnerships,
                  give leaders the time and space to focus on the impact of the
                  organisation.
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delayClass="delay-400" data-id="element-487">
              <div className="bg-brand-cream p-10 border-grid border-brand-shape/50 h-full transition-colors hover:border-brand-charcoal/30 flex flex-col group" data-id="element-488">
                <div className="w-12 h-12 rounded-full bg-brand-card/60 flex items-center justify-center mb-6 icon-hover" data-id="element-489">
                  <Share2 className="w-6 h-6 text-brand-red" strokeWidth={1} data-id="element-490" />
                </div>
                <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-491">
                  We share who we back
                </h3>
                <p className="text-brand-brown leading-relaxed flex-grow" data-id="element-492">
                  Every organisation in this portfolio is one we currently fund
                  ourselves and intend to continue funding. This is not a way to
                  wind down but rather to double down.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Image Breaker 2 - Floating Market / Community */}
      <AnimatedSection data-id="element-493">
        <div className="relative h-64 md:h-96 w-full overflow-hidden" data-id="element-494">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform hover:scale-105 transition-transform duration-1000" style={{
          backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/oycjRBLuBGVUMSr6Xgqnpb/FromTerri_Cambodia2.jpg")'
        }} data-id="element-495" />
          <div className="absolute inset-0 bg-brand-charcoal/30 mix-blend-multiply" data-id="element-496" />
          <div className="absolute inset-0 bg-texture-overlay mix-blend-overlay" data-id="element-497" />
        </div>
      </AnimatedSection>

      {/* Where We Work */}
      <section className="py-24 overflow-hidden" data-id="element-498">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-499">
          <AnimatedSection data-id="element-500">
            <div className="max-w-3xl" data-id="element-501">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-502">
                Where we work
              </h2>
              <p className="text-lg text-brand-brown mb-8 leading-relaxed" data-id="element-503">
                We work only in geographies where we have deep, lived experience
                as residents, practitioners and long-term partners. Our work
                spans six countries across Southeast Asia.
              </p>
              <Link to="/who-we-fund" className="inline-flex items-center px-6 py-3 border border-brand-red text-brand-red font-semibold rounded-full hover:bg-brand-red hover:text-white transition-all duration-300 group" data-id="element-504">
                Discover our portfolio
                <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-505" />
              </Link>
            </div>
          </AnimatedSection>
        </div>

        {/* Carousel */}
        <AnimatedSection delayClass="delay-200" data-id="element-506">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-507">
            {/* Blurred edges */}
            <div className="absolute left-4 sm:left-6 lg:left-8 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-brand-cream to-transparent z-10 pointer-events-none" data-id="element-508"></div>
            <div className="absolute right-4 sm:right-6 lg:right-8 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-brand-cream to-transparent z-10 pointer-events-none" data-id="element-509"></div>

            <style data-id="element-510">{`
              @keyframes scroll {
                0% { transform: translateX(0); }
                100% { transform: translateX(calc(-100% - 1rem)); }
              }
              .animate-scroll {
                animation: scroll 20s linear infinite;
              }
              .carousel-container:hover .animate-scroll {
                animation-play-state: paused;
              }
            `}</style>

            <div className="flex gap-4 overflow-hidden carousel-container py-2" data-id="element-511">
              {[...Array(2)].map((_, i) => <div key={i} className="flex gap-4 animate-scroll shrink-0" aria-hidden={i === 1} data-id="element-512">
                  {['Cambodia', 'Philippines', 'Thailand', 'Malaysia', 'Singapore', 'Indonesia'].map(country => <div key={country} className="bg-brand-cream border-grid border-brand-shape/50 px-8 py-4 text-center min-w-[160px] transition-colors hover:border-brand-charcoal/30" data-id="element-513">
                      <span className="text-brand-charcoal font-medium" data-id="element-514">
                        {country}
                      </span>
                    </div>)}
                </div>)}
            </div>
          </div>
        </AnimatedSection>
      </section>

      {/* Image Breaker 3 - Temple / Landscape */}
      <AnimatedSection data-id="element-515">
        <div className="relative h-64 md:h-96 w-full overflow-hidden" data-id="element-516">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform hover:scale-105 transition-transform duration-1000" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=2070&auto=format&fit=crop")'
        }} data-id="element-517" />
          <div className="absolute inset-0 bg-brand-charcoal/20 mix-blend-multiply" data-id="element-518" />
          <div className="absolute inset-0 bg-texture-overlay mix-blend-overlay" data-id="element-519" />
        </div>
      </AnimatedSection>

      {/* Who Runs the Fund */}
      <section className="text-white py-24" style={{
      backgroundColor: '#243462'
    }} data-id="element-520">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-521">
          <AnimatedSection data-id="element-522">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-8" data-id="element-523">
              Who runs the Fund
            </h2>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-200" data-id="element-524">
            <p className="text-lg md:text-xl text-white/80 mb-10 leading-relaxed" data-id="element-525">
              The Firetree Fund is managed by Sreya Bhattacharya, governed by
              the Firetree Board chaired by Francesco Caruso, and advised by a
              regional panel of technical experts chaired by Nicky Wilkinson.
              The panel brings decades of direct experience across child
              protection, education and nonprofit leadership in Southeast Asia.
            </p>
          </AnimatedSection>
          <AnimatedSection delayClass="delay-400" data-id="element-526">
            <a href="https://firetree.org/team" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 border rounded-full font-semibold transition-all duration-300 group" style={{
            color: '#aacafe',
            borderColor: '#aacafe'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#aacafe';
            e.currentTarget.style.color = '#243462';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#aacafe';
          }} data-id="element-527">
              Meet the entire Firetree team at firetree.org/team
              <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform -rotate-45" data-id="element-528" />
            </a>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}